import React, { createContext, useContext, useEffect, useState } from 'react';
import { FirebaseContext } from 'components/common/Firebase';

export const AuthorizedUserContext = createContext();
export const AuthorizedUserProvider = props => {
  const firebase = useContext(FirebaseContext);

  const initialState = {
    authorizedUser: null,
    error: false,
    fetching: false,
    listener: null,
    loaded: false
  };

  const [state, setState] = useState(initialState);

  const listenToAuthorizedUser = firebase => {
    setState({ ...state, fetching: true });
    const listener = firebase.auth.onAuthStateChanged(authorizedUser => {
      setState({
        ...state,
        authorizedUser: authorizedUser,
        fetching: false,
        loaded: true
      });
    });
    setState({ ...state, listener: listener });
  };

  const stopListening = listener => {
    listener();
  };

  useEffect(() => {
    // Runs when any prop changes
    listenToAuthorizedUser(firebase);
    return () => {
      // cleanup function
      stopListening(state.listener);
    };
  }, [firebase]);

  return (
    <AuthorizedUserContext.Provider value={state.authorizedUser}>
      {props.children}
    </AuthorizedUserContext.Provider>
  );
};
